import React from "react";
import { Helmet } from "react-helmet";
import Breadcrumb from "../../shared/breadcrumb/Breadcrumb";
import { useTranslation } from "react-i18next";
import VerticalTerrace from "../../components/vertical-terrace/VerticalTerrace";

function VerticalTerracePage({ setShow }) {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>VerticalTerrace Maintenance | Vinca Horticulture & Landscaping</title>
        <meta name="keyword" content="Vinca Horticulture & Landscaping" />
        <meta name="description" content="Vinca Horticulture & Landscaping" />
      </Helmet>
      <Breadcrumb title={"VerticalTerrace Maintenance"} t={t} />
      <VerticalTerrace />
    </>
  );
}

export default VerticalTerracePage;
